// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .absolute {
    position: absolute;
  }
  
  .inline-block {
    display: inline-block;
  }
  
  .loader {
    display: flex;
    margin: 0.25em 0;
  }
  
  .w-2 {
    width: 0.5em;
  }
  
  .dash {
    animation: dashArray 2s ease-in-out infinite,
      dashOffset 2s linear infinite;
  }
  
  .spin {
    animation: spinDashArray 2s ease-in-out infinite,
      spin 8s ease-in-out infinite,
      dashOffset 2s linear infinite;
    transform-origin: center;
  }
  
  @keyframes dashArray {
    0% {
      stroke-dasharray: 0 1 359 0;
    }
  
    50% {
      stroke-dasharray: 0 359 1 0;
    }
  
    100% {
      stroke-dasharray: 359 1 0 0;
    }
  }
  
  @keyframes spinDashArray {
    0% {
      stroke-dasharray: 270 90;
    }
  
    50% {
      stroke-dasharray: 0 360;
    }
  
    100% {
      stroke-dasharray: 270 90;
    }
  }
  
  @keyframes dashOffset {
    0% {
      stroke-dashoffset: 365;
    }
  
    100% {
      stroke-dashoffset: 5;
    }
  }
  
  @keyframes spin {
    0% {
      rotate: 0deg;
    }
  
    12.5%,
    25% {
      rotate: 270deg;
    }
  
    37.5%,
    50% {
      rotate: 540deg;
    }
  
    62.5%,
    75% {
      rotate: 810deg;
    }
  
    87.5%,
    100% {
      rotate: 1080deg;
    }
  }
   */
   #preloader {
    background-color: var(--tg-color-white-default);
    height: 100%;
    width: 100%;
    position: fixed;
    margin-top: 0px;
    top: 0px;
    z-index: 9999;
  }
  
  #preloader .loader .loader-container {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 100px;
    height: 100px;
    border: 3px solid var(--tg-color-gray-1);
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -o-border-radius: 50%;
    -ms-border-radius: 50%;
    border-radius: 50%;
  }
  
  #preloader .loader .loader-container::before {
    position: absolute;
    content: "";
    display: block;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 100px;
    height: 100px;
    border-top: 3px solid var(--tg-theme-primary);
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -o-border-radius: 50%;
    -ms-border-radius: 50%;
    border-radius: 50%;
    animation: loaderspin 1.8s infinite ease-in-out;
    -webkit-animation: loaderspin 1.8s infinite ease-in-out;
  }
  
  #preloader .loader .loader-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 80px;
    text-align: center;
  }
  
  #preloader .loader .loader-icon img {
    animation: loaderpulse alternate 900ms infinite;
    width: 40px;
  }
  
  @keyframes loaderspin {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
  
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
  
  @-webkit-keyframes loaderspin {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
  
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
  
  @keyframes loaderpulse {
    0% {
      transform: scale(1);
    }
  
    100% {
      transform: scale(1.2);
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/layout/loading.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA4FI;GACD;IACC,+CAA+C;IAC/C,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,wCAAwC;IACxC,0BAA0B;IAC1B,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,6CAA6C;IAC7C,0BAA0B;IAC1B,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,+CAA+C;IAC/C,uDAAuD;EACzD;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gCAAgC;IAChC,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,+CAA+C;IAC/C,WAAW;EACb;;EAEA;IACE;MACE,6CAA6C;IAC/C;;IAEA;MACE,+CAA+C;IACjD;EACF;;EAEA;IACE;MACE,6CAA6C;IAC/C;;IAEA;MACE,+CAA+C;IACjD;EACF;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;IACvB;EACF","sourcesContent":["/* .absolute {\n    position: absolute;\n  }\n  \n  .inline-block {\n    display: inline-block;\n  }\n  \n  .loader {\n    display: flex;\n    margin: 0.25em 0;\n  }\n  \n  .w-2 {\n    width: 0.5em;\n  }\n  \n  .dash {\n    animation: dashArray 2s ease-in-out infinite,\n      dashOffset 2s linear infinite;\n  }\n  \n  .spin {\n    animation: spinDashArray 2s ease-in-out infinite,\n      spin 8s ease-in-out infinite,\n      dashOffset 2s linear infinite;\n    transform-origin: center;\n  }\n  \n  @keyframes dashArray {\n    0% {\n      stroke-dasharray: 0 1 359 0;\n    }\n  \n    50% {\n      stroke-dasharray: 0 359 1 0;\n    }\n  \n    100% {\n      stroke-dasharray: 359 1 0 0;\n    }\n  }\n  \n  @keyframes spinDashArray {\n    0% {\n      stroke-dasharray: 270 90;\n    }\n  \n    50% {\n      stroke-dasharray: 0 360;\n    }\n  \n    100% {\n      stroke-dasharray: 270 90;\n    }\n  }\n  \n  @keyframes dashOffset {\n    0% {\n      stroke-dashoffset: 365;\n    }\n  \n    100% {\n      stroke-dashoffset: 5;\n    }\n  }\n  \n  @keyframes spin {\n    0% {\n      rotate: 0deg;\n    }\n  \n    12.5%,\n    25% {\n      rotate: 270deg;\n    }\n  \n    37.5%,\n    50% {\n      rotate: 540deg;\n    }\n  \n    62.5%,\n    75% {\n      rotate: 810deg;\n    }\n  \n    87.5%,\n    100% {\n      rotate: 1080deg;\n    }\n  }\n   */\n   #preloader {\n    background-color: var(--tg-color-white-default);\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    margin-top: 0px;\n    top: 0px;\n    z-index: 9999;\n  }\n  \n  #preloader .loader .loader-container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    width: 100px;\n    height: 100px;\n    border: 3px solid var(--tg-color-gray-1);\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -o-border-radius: 50%;\n    -ms-border-radius: 50%;\n    border-radius: 50%;\n  }\n  \n  #preloader .loader .loader-container::before {\n    position: absolute;\n    content: \"\";\n    display: block;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    width: 100px;\n    height: 100px;\n    border-top: 3px solid var(--tg-theme-primary);\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -o-border-radius: 50%;\n    -ms-border-radius: 50%;\n    border-radius: 50%;\n    animation: loaderspin 1.8s infinite ease-in-out;\n    -webkit-animation: loaderspin 1.8s infinite ease-in-out;\n  }\n  \n  #preloader .loader .loader-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    width: 80px;\n    text-align: center;\n  }\n  \n  #preloader .loader .loader-icon img {\n    animation: loaderpulse alternate 900ms infinite;\n    width: 40px;\n  }\n  \n  @keyframes loaderspin {\n    0% {\n      transform: translate(-50%, -50%) rotate(0deg);\n    }\n  \n    100% {\n      transform: translate(-50%, -50%) rotate(360deg);\n    }\n  }\n  \n  @-webkit-keyframes loaderspin {\n    0% {\n      transform: translate(-50%, -50%) rotate(0deg);\n    }\n  \n    100% {\n      transform: translate(-50%, -50%) rotate(360deg);\n    }\n  }\n  \n  @keyframes loaderpulse {\n    0% {\n      transform: scale(1);\n    }\n  \n    100% {\n      transform: scale(1.2);\n    }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
